<!-- =========================================================================================
  File Name: group.vue
  Description: User Group
========================================================================================== -->

<template>
  <div id="user-group">

    <vx-card title="会员用户组">
      <vs-table stripe :data="list" noDataText="暂无用户组">
        <template slot="thead">
          <vs-th width="60">ID</vs-th>
          <vs-th width="200">名称</vs-th>
          <vs-th width="150">可下注</vs-th>
          <vs-th width="150">日工资</vs-th>
          <vs-th width="150">分红</vs-th>
          <vs-th width="150">充值</vs-th>
          <vs-th width="150">提现</vs-th>
          <vs-th width="150">计入报表</vs-th>
          <vs-th width="190">开户模式</vs-th>
          <vs-th width="150">返点锁定</vs-th>
          <vs-th width="150">最小返点差</vs-th>
          <vs-th width="150">可开同级数量</vs-th>
		  <vs-th width="150">团队流水</vs-th>
		  <vs-th width="150">有效人数</vs-th>
          <vs-th width="190">下级</vs-th>
          <vs-th>操作</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="index" v-for="(item, index) in list" >
            <vs-td :data="item.id">{{item.id}}</vs-td>
            <vs-td :data="item.name">
              <vs-input v-model="item.name" class="w-full" />
            </vs-td>
            <vs-td :data="item.canLottery">
              <vs-select class="w-full" v-model="list[index].canLottery">
                <vs-select-item value="1" text="是" />
                <vs-select-item value="0" text="否" />
              </vs-select>
            </vs-td>
            <vs-td :data="item.canSalary">
              <vs-select class="w-full" v-model="list[index].canSalary">
                <vs-select-item value="1" text="是" />
                <vs-select-item value="0" text="否" />
              </vs-select>
            </vs-td>
            <vs-td :data="item.canBonus">
              <vs-select class="w-full" v-model="list[index].canBonus">
                <vs-select-item value="1" text="是" />
                <vs-select-item value="0" text="否" />
              </vs-select>
            </vs-td>
            <vs-td :data="item.canRecharge">
              <vs-select class="w-full" v-model="list[index].canRecharge">
                <vs-select-item value="1" text="是" />
                <vs-select-item value="0" text="否" />
              </vs-select>
            </vs-td>
            <vs-td :data="item.canCash">
              <vs-select class="w-full" v-model="list[index].canCash">
                <vs-select-item value="1" text="是" />
                <vs-select-item value="0" text="否" />
              </vs-select>
            </vs-td>
            <vs-td :data="item.joinReport">
              <vs-select class="w-full" v-model="list[index].joinReport">
                <vs-select-item value="1" text="是" />
                <vs-select-item value="0" text="否" />
              </vs-select>
            </vs-td>
            <vs-td :data="item.openMode">
              <vs-select class="w-full" v-model="list[index].openMode">
                <vs-select-item value="1" text="同级+下级" />
                <vs-select-item value="2" text="仅同级" />
                <vs-select-item value="3" text="仅下级" />
                <vs-select-item value="4" text="仅下一级" />
              </vs-select>
            </vs-td>
            <vs-td :data="item.lockFandian">
              <vs-select class="w-full" v-model="list[index].lockFandian">
                <vs-select-item value="1" text="是" />
                <vs-select-item value="0" text="否" />
              </vs-select>
            </vs-td>
            <vs-td :data="item.minFandianCha">
              <vs-input v-model="item.minFandianCha" class="w-full" />
            </vs-td>
            <vs-td :data="item.maxSameLevel">
              <vs-input v-model="item.maxSameLevel" class="w-full" />
            </vs-td>
			<vs-td :data="item.up_team_money">
			  <vs-input v-model="item.up_team_money" class="w-full" />
			</vs-td>
			<vs-td :data="item.up_team_num">
			  <vs-input v-model="item.up_team_num" class="w-full" />
			</vs-td>
            <vs-td :data="item.subId">
              <vs-input :value="groupName[item.subId] || '无'" class="w-full" disabled />
            </vs-td>
            <vs-td>
              <vs-button color="primary" type="filled" size="small" @click="modify" :data-index="index">更改</vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

    </vx-card>

  </div>
</template>

<script>

export default {
  data() {
    return {
      list: [],
      groupName: {}
    }
  },
  methods: {
    modify (e) {
      const dataset = e.currentTarget.dataset
      const postdata = this.list[dataset.index]
      postdata.authKey = localStorage.getItem('authKey')
      this.$utils.post('user-groupDo', postdata).then(res => {
        this.$vs.dialog({
          title: '提示',
          text: res,
          acceptText: '确认'
        })
        this.load()
      })
    },
    load () {
      this.$utils.post('user-groupList', { authKey: localStorage.getItem('authKey') }).then(res => {
        for (let i = 0; i < res.length; i++) {
          this.groupName[res[i].id] = res[i].name
        }
        this.list = res
      })
    }
  },
  mounted () {
    this.load()
  }
}
</script>
